import { render, staticRenderFns } from "./CustomFourColumTable.vue?vue&type=template&id=045793db&scoped=true&"
import script from "./CustomFourColumTable.vue?vue&type=script&lang=js&"
export * from "./CustomFourColumTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomFourColumTable.vue?vue&type=style&index=0&id=045793db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045793db",
  null
  
)

export default component.exports